/**
 * Paste-ready "Inside Volume 4" carousel: vanilla HTML + CSS + JS, no libraries.
 * Copy everything between the opening and closing backticks into an HTML block.
 * Image paths are placeholders (slide-01.webp … slide-09.webp): swap in your real files.
 * All CSS is scoped under .slr4 so it won't leak into the host page.
 */
export const volume4CarouselHtml = String.raw`<!-- Sailing Lesson Ready · Inside Volume 4 carousel -->
<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600&family=Inter:wght@400;500;600&display=swap" rel="stylesheet">

<section class="slr4" id="slr4" aria-labelledby="slr4-title">
<style>
.slr4{--navy:#14365D;--white:#FBFAF6;--sand:#EFE6D2;--glass:#7FC4C0;--orange:#F28C28;--orange-text:#C4620E;--yellow:#F2C230;--ink:#1B2430;--muted:#5B6573;--line:#E3E8EF;--ease:cubic-bezier(.23,1,.32,1);
  width:100%;background:var(--white);color:var(--ink);font-family:Inter,system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;font-size:16px;line-height:1.5;padding:56px 0 64px;overflow:hidden;-webkit-font-smoothing:antialiased;text-align:left}
.slr4 *,.slr4 *::before,.slr4 *::after{box-sizing:border-box}
.slr4 h2,.slr4 p,.slr4 ul,.slr4 li{margin:0;padding:0}
.slr4 ul{list-style:none}
.slr4 button{font:inherit;color:inherit;background:none;border:0;padding:0;margin:0;cursor:pointer;-webkit-tap-highlight-color:transparent;-webkit-appearance:none;appearance:none}
.slr4 img{display:block;border:0}
.slr4 [hidden]{display:none!important}
.slr4__inner{max-width:1160px;margin:0 auto}

/* Header */
.slr4__head{position:relative;max-width:880px;margin:0 auto;padding:0 20px;text-align:center}
.slr4__course{position:absolute;left:0;top:-28px;width:100%;height:190px;pointer-events:none;z-index:0}
.slr4__chip,.slr4__title,.slr4__sub{position:relative;z-index:1}
.slr4__chip{display:inline-block;background:var(--orange);color:var(--navy);font-family:"Barlow Condensed","Arial Narrow",sans-serif;font-weight:600;font-size:14px;line-height:1.2;letter-spacing:.1em;text-transform:uppercase;padding:6px 12px;border-radius:999px}
.slr4__title{margin-top:16px;font-family:"Barlow Condensed","Arial Narrow",sans-serif;font-weight:600;text-transform:uppercase;color:var(--navy);font-size:clamp(32px,8.2vw,56px);line-height:1;letter-spacing:.005em;text-wrap:balance}
.slr4__sub{margin:14px auto 0;max-width:64ch;font-size:16px;color:var(--ink);text-wrap:pretty}

/* Carousel */
.slr4__stage{position:relative;margin-top:28px}
.slr4__track{position:relative;display:flex;gap:14px;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;padding:12px 11% 28px;scrollbar-width:none;-webkit-overflow-scrolling:touch;overscroll-behavior-x:contain;outline:none}
.slr4__track::-webkit-scrollbar{display:none}
.slr4__track:focus-visible{box-shadow:inset 0 0 0 3px rgba(242,140,40,.55);border-radius:16px}
.slr4__slide{flex:0 0 78%;scroll-snap-align:center;scroll-snap-stop:always}
.slr4__card{display:block;width:100%;aspect-ratio:9/16;background:#fff;border:1px solid var(--line);border-radius:12px;box-shadow:0 10px 28px rgba(20,54,93,.12);overflow:hidden;transition:transform 250ms var(--ease),opacity 250ms var(--ease)}
.slr4__card img{width:100%;height:100%;object-fit:contain;background:#fff}
.slr4__card:focus-visible{outline:3px solid var(--orange);outline-offset:3px}
.slr4__arrow{display:none}

/* Dots + counter */
.slr4__nav{display:flex;align-items:center;justify-content:center;gap:14px;padding:0 20px}
.slr4__dots{display:flex;align-items:center}
.slr4__dot{width:24px;height:28px;display:flex;align-items:center;justify-content:center}
.slr4__dot::before{content:"";display:block;width:8px;height:8px;border-radius:999px;background:#C5CDD8;transition:width 200ms var(--ease),background-color 200ms var(--ease)}
.slr4__dot[aria-current="true"]{width:34px}
.slr4__dot[aria-current="true"]::before{width:22px;background:var(--orange)}
.slr4__dot:focus-visible{outline:2px solid var(--navy);outline-offset:-2px;border-radius:6px}
.slr4__count{font-size:14px;font-variant-numeric:tabular-nums;color:var(--muted);white-space:nowrap}
.slr4__count b{color:var(--navy);font-weight:600}

/* Caption */
.slr4__capwrap{padding:0 20px}
.slr4__caption{max-width:680px;margin:20px auto 0;background:var(--sand);border-radius:12px;padding:16px 20px;color:var(--navy)}
.slr4__capinner{display:flex;align-items:flex-start;gap:16px;min-height:4.5em;transition:opacity 150ms var(--ease)}
.slr4__capinner.is-fading{opacity:0}
.slr4__num{flex:none;font-family:"Barlow Condensed","Arial Narrow",sans-serif;font-weight:600;font-size:28px;line-height:1;color:var(--orange-text);padding-top:1px}
.slr4__captext{font-size:16px;line-height:1.5}
.slr4__note{margin-top:14px;padding:0 20px;text-align:center;font-size:14px;color:var(--muted)}

/* Lightbox */
.slr4__lb{position:fixed;inset:0;z-index:2147483000;display:flex;flex-direction:column;background:rgba(10,26,46,.94);opacity:0;transition:opacity 200ms var(--ease)}
.slr4__lb.is-open{opacity:1}
.slr4__lbbar{flex:none;display:flex;align-items:center;justify-content:space-between;padding:12px 16px}
.slr4__lbcount{font-size:14px;font-variant-numeric:tabular-nums;color:rgba(255,255,255,.85)}
.slr4__lbclose{width:44px;height:44px;border-radius:999px;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,.12);color:#fff;transition:background-color 150ms var(--ease)}
.slr4__lbclose:hover{background:rgba(255,255,255,.22)}
.slr4__lbtrack{flex:1;min-height:0;display:flex;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;scrollbar-width:none;overscroll-behavior:contain}
.slr4__lbtrack::-webkit-scrollbar{display:none}
.slr4__lbslide{flex:0 0 100%;scroll-snap-align:center;display:flex;align-items:center;justify-content:center;padding:0 16px 20px}
.slr4__lbslide img{width:auto;height:auto;max-width:100%;max-height:calc(100vh - 96px);max-height:calc(100dvh - 96px);object-fit:contain;background:#fff;border-radius:8px;transform:scale(.96);transition:transform 220ms var(--ease)}
.slr4__lb.is-open .slr4__lbslide img{transform:none}
.slr4__lbarrow{display:none}
.slr4__lb button:focus-visible{outline:3px solid var(--orange);outline-offset:2px}

@media (min-width:900px){
  .slr4{padding:80px 0 88px}
  .slr4__sub{font-size:17px}
  .slr4__stage{display:grid;grid-template-columns:52px minmax(0,1fr) 52px;align-items:center;gap:16px;margin-top:36px;padding:0 24px}
  .slr4__track{gap:24px;padding:16px 35% 32px}
  .slr4__slide{flex-basis:30%}
  .slr4__slide .slr4__card{transform:scale(.9);opacity:.7}
  .slr4__slide .slr4__card:hover{opacity:.85}
  .slr4__slide.is-active .slr4__card{transform:none;opacity:1}
  .slr4__arrow{display:flex;align-items:center;justify-content:center;width:52px;height:52px;border-radius:999px;background:var(--navy);color:#fff;box-shadow:0 8px 20px -8px rgba(20,54,93,.5);transition:background-color 150ms var(--ease),transform 120ms var(--ease),opacity 150ms var(--ease)}
  .slr4__arrow:hover{background:#0E2847}
  .slr4__arrow:active{transform:scale(.95)}
  .slr4__arrow:disabled{opacity:.3;cursor:default}
  .slr4__arrow:focus-visible{outline:3px solid var(--orange);outline-offset:3px}
  .slr4__capinner{min-height:3em}
  .slr4__lbarrow{position:absolute;top:50%;margin-top:-24px;display:flex;align-items:center;justify-content:center;width:48px;height:48px;border-radius:999px;background:#fff;color:var(--navy);transition:opacity 150ms var(--ease)}
  .slr4__lbarrow:disabled{opacity:.3;cursor:default}
  .slr4__lbarrow--prev{left:24px}
  .slr4__lbarrow--next{right:24px}
  .slr4__lbslide{padding:0 96px 24px}
}
@media (prefers-reduced-motion:reduce){
  .slr4 *,.slr4 *::before{transition:none!important}
}
</style>

  <div class="slr4__inner">
    <header class="slr4__head">
      <svg class="slr4__course" viewBox="0 0 880 190" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
        <path d="M10 170 C 180 70, 360 190, 560 100 S 790 40, 836 44" fill="none" stroke="#7FC4C0" stroke-width="1.5" stroke-dasharray="6 7" stroke-linecap="round"/>
        <circle cx="844" cy="44" r="7" fill="#F28C28"/>
      </svg>
      <span class="slr4__chip">Inside Volume 4 of 6</span>
      <h2 class="slr4__title" id="slr4-title">See exactly what you get: every lesson on one page, planned for every wind</h2>
      <p class="slr4__sub">Course diagrams, dock briefs, common errors and fixes, plus a Light Air and Wrong Air swap on every card.</p>
    </header>

    <div class="slr4__stage">
      <button class="slr4__arrow" type="button" data-prev aria-label="Previous page">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>
      </button>
      <ul class="slr4__track" tabindex="0" aria-label="Volume 4 pages. Use the left and right arrow keys to browse."></ul>
      <button class="slr4__arrow" type="button" data-next aria-label="Next page">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>
      </button>
    </div>

    <div class="slr4__nav">
      <div class="slr4__dots" aria-label="Choose a page"></div>
      <p class="slr4__count" aria-hidden="true"><b data-count-now>1</b> / <span data-count-total>9</span></p>
    </div>

    <div class="slr4__capwrap">
      <div class="slr4__caption">
        <div class="slr4__capinner">
          <span class="slr4__num" aria-hidden="true">01</span>
          <p class="slr4__captext" aria-live="polite"></p>
        </div>
      </div>
    </div>

    <p class="slr4__note">Volume 4 is one of 6 volumes included in the pack.</p>
  </div>

  <div class="slr4__lb" role="dialog" aria-modal="true" aria-label="Volume 4 page viewer" hidden>
    <div class="slr4__lbbar">
      <p class="slr4__lbcount" aria-live="polite">1 / 9</p>
      <button class="slr4__lbclose" type="button" aria-label="Close viewer">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>
      </button>
    </div>
    <div class="slr4__lbtrack"></div>
    <button class="slr4__lbarrow slr4__lbarrow--prev" type="button" aria-label="Previous page">
      <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>
    </button>
    <button class="slr4__lbarrow slr4__lbarrow--next" type="button" aria-label="Next page">
      <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>
    </button>
  </div>
</section>

<script>
(function () {
  var root = document.getElementById('slr4');
  if (!root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');

  /* Swap the src values for your real files. Titles are used as alt text. */
  var SLIDES = [
    { src: 'slide-01.webp', title: 'Volume 4 · Race Training cover', caption: 'Volume 4 · Race Training: coach-ready drills for starts, upwind, marks, downwind and race day.' },
    { src: 'slide-02.webp', title: 'LC-77 · Rabbit Start Lesson Card', caption: 'Every Lesson Card fits on one page: setup diagram, dock brief, steps, what to watch for and the fix.' },
    { src: 'slide-03.webp', title: 'LC-74 · Find the Line Lesson Card', caption: 'Top-down course diagrams you can set up on the water tomorrow morning.' },
    { src: 'slide-04.webp', title: 'Late and buried vs. full speed: start comparison', caption: 'Side-by-side comparisons that show sailors what a good start looks like.' },
    { src: 'slide-05.webp', title: 'The Coach Boat Lane', caption: 'The Coach Boat Lane: where to sit, what to watch and when to call.' },
    { src: 'slide-06.webp', title: 'Pressure and shifts', caption: 'Theory turned into pictures sailors actually remember.' },
    { src: 'slide-07.webp', title: 'LC-88 · Pressure Downwind Lesson Card', caption: 'Downwind drills built around reading pressure, not luck.' },
    { src: 'slide-08.webp', title: 'Five rule situations', caption: 'The five rule situations new racers meet first, explained in plain words.' },
    { src: 'slide-09.webp', title: 'Coach boat field card', caption: 'A field card for the coach boat: Wind Check, drill builder, start checklist and 20 race cues.' }
  ];

  var total = SLIDES.length;
  var track = root.querySelector('.slr4__track');
  var dotsWrap = root.querySelector('.slr4__dots');
  var countNow = root.querySelector('[data-count-now]');
  var capInner = root.querySelector('.slr4__capinner');
  var capNum = root.querySelector('.slr4__num');
  var capText = root.querySelector('.slr4__captext');
  var prevBtn = root.querySelector('[data-prev]');
  var nextBtn = root.querySelector('[data-next]');
  var lb = root.querySelector('.slr4__lb');
  var lbTrack = root.querySelector('.slr4__lbtrack');
  var lbCount = root.querySelector('.slr4__lbcount');
  var lbClose = root.querySelector('.slr4__lbclose');
  var lbPrev = root.querySelector('.slr4__lbarrow--prev');
  var lbNext = root.querySelector('.slr4__lbarrow--next');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var active = -1, lbIndex = 0, lastFocus = null, fadeTimer = null, closeTimer = null;
  var lockIndex = -1, lockUntil = 0, ticking = false, lbTicking = false, prevOverflow = '';
  var slideEls = [], dotEls = [];

  root.querySelector('[data-count-total]').textContent = total;

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function make(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }
  function makeImg(s, eager) {
    var img = make('img');
    img.src = s.src;
    img.alt = s.title;
    img.width = 1125;
    img.height = 2000;
    img.decoding = 'async';
    img.loading = eager ? 'eager' : 'lazy';
    return img;
  }

  SLIDES.forEach(function (s, i) {
    var li = make('li', 'slr4__slide');
    li.setAttribute('aria-roledescription', 'slide');
    li.setAttribute('aria-label', (i + 1) + ' of ' + total + ': ' + s.title);
    var card = make('button', 'slr4__card');
    card.type = 'button';
    card.setAttribute('aria-label', 'Open full screen: ' + s.title);
    card.appendChild(makeImg(s, i < 2));
    card.addEventListener('click', function () { openLb(i); });
    li.appendChild(card);
    track.appendChild(li);
    slideEls.push(li);

    var dot = make('button', 'slr4__dot');
    dot.type = 'button';
    dot.setAttribute('aria-label', 'Go to page ' + (i + 1) + ': ' + s.title);
    dot.addEventListener('click', function () { goTo(i); });
    dotsWrap.appendChild(dot);
    dotEls.push(dot);

    var ls = make('div', 'slr4__lbslide');
    ls.appendChild(makeImg(s, false));
    ls.addEventListener('click', function (e) { if (e.target === ls) closeLb(); });
    lbTrack.appendChild(ls);
  });

  function swapCaption(i, instant) {
    clearTimeout(fadeTimer);
    function apply() {
      capNum.textContent = pad(i + 1);
      capText.textContent = SLIDES[i].caption;
      capInner.classList.remove('is-fading');
    }
    if (instant || reduce) { apply(); return; }
    capInner.classList.add('is-fading');
    fadeTimer = setTimeout(apply, 150);
  }

  function setActive(i, instant) {
    if (i === active) return;
    active = i;
    for (var k = 0; k < total; k++) {
      var on = k === i;
      slideEls[k].classList.toggle('is-active', on);
      slideEls[k].firstChild.tabIndex = on ? 0 : -1;
      if (on) dotEls[k].setAttribute('aria-current', 'true');
      else dotEls[k].removeAttribute('aria-current');
    }
    countNow.textContent = i + 1;
    prevBtn.disabled = i === 0;
    nextBtn.disabled = i === total - 1;
    swapCaption(i, instant);
  }

  function leftFor(i) {
    var li = slideEls[i];
    return li.offsetLeft - (track.clientWidth - li.offsetWidth) / 2;
  }

  function goTo(i, instant) {
    i = Math.max(0, Math.min(total - 1, i));
    lockIndex = i;
    lockUntil = Date.now() + 700;
    track.scrollTo({ left: leftFor(i), behavior: instant || reduce ? 'auto' : 'smooth' });
    setActive(i);
  }

  function nearest() {
    var center = track.scrollLeft + track.clientWidth / 2;
    var best = 0, bestDist = Infinity;
    for (var k = 0; k < total; k++) {
      var li = slideEls[k];
      var d = Math.abs(li.offsetLeft + li.offsetWidth / 2 - center);
      if (d < bestDist) { bestDist = d; best = k; }
    }
    return best;
  }

  track.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var n = nearest();
      if (Date.now() < lockUntil && n !== lockIndex) return;
      setActive(n);
    });
  }, { passive: true });

  ['pointerdown', 'touchstart', 'wheel'].forEach(function (type) {
    track.addEventListener(type, function () { lockUntil = 0; }, { passive: true });
  });

  track.addEventListener('keydown', function (e) {
    var next = null;
    if (e.key === 'ArrowRight') next = active + 1;
    else if (e.key === 'ArrowLeft') next = active - 1;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = total - 1;
    if (next === null) return;
    e.preventDefault();
    goTo(next);
    if (document.activeElement !== track) slideEls[active].firstChild.focus({ preventScroll: true });
  });

  prevBtn.addEventListener('click', function () { goTo(active - 1); });
  nextBtn.addEventListener('click', function () { goTo(active + 1); });

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { goTo(active, true); }, 120);
  });

  /* Lightbox */
  function updateLb() {
    lbCount.textContent = (lbIndex + 1) + ' / ' + total;
    lbPrev.disabled = lbIndex === 0;
    lbNext.disabled = lbIndex === total - 1;
  }

  function lbGo(i, instant) {
    lbIndex = Math.max(0, Math.min(total - 1, i));
    lbTrack.scrollTo({ left: lbIndex * lbTrack.clientWidth, behavior: instant || reduce ? 'auto' : 'smooth' });
    updateLb();
  }

  function openLb(i) {
    clearTimeout(closeTimer);
    lastFocus = document.activeElement;
    prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    lb.hidden = false;
    lbGo(i, true);
    goTo(i, true);
    requestAnimationFrame(function () {
      lbTrack.scrollLeft = lbIndex * lbTrack.clientWidth;
      lb.classList.add('is-open');
      lbClose.focus({ preventScroll: true });
    });
  }

  function closeLb() {
    if (lb.hidden) return;
    lb.classList.remove('is-open');
    document.documentElement.style.overflow = prevOverflow;
    goTo(lbIndex, true);
    closeTimer = setTimeout(function () { lb.hidden = true; }, reduce ? 0 : 200);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  lbTrack.addEventListener('scroll', function () {
    if (lbTicking) return;
    lbTicking = true;
    requestAnimationFrame(function () {
      lbTicking = false;
      var w = lbTrack.clientWidth || 1;
      var i = Math.round(lbTrack.scrollLeft / w);
      if (i !== lbIndex) { lbIndex = i; updateLb(); }
    });
  }, { passive: true });

  lbClose.addEventListener('click', closeLb);
  lbPrev.addEventListener('click', function () { lbGo(lbIndex - 1); });
  lbNext.addEventListener('click', function () { lbGo(lbIndex + 1); });
  lb.querySelector('.slr4__lbbar').addEventListener('click', function (e) {
    if (e.target === e.currentTarget) closeLb();
  });

  document.addEventListener('keydown', function (e) {
    if (lb.hidden || !lb.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); closeLb(); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); lbGo(lbIndex + 1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); lbGo(lbIndex - 1); }
    else if (e.key === 'Tab') {
      var items = [lbClose, lbPrev, lbNext].filter(function (b) { return !b.disabled && b.offsetParent !== null; });
      if (!items.length) return;
      var idx = items.indexOf(document.activeElement);
      e.preventDefault();
      var to = e.shiftKey ? (idx <= 0 ? items.length - 1 : idx - 1) : (idx === items.length - 1 ? 0 : idx + 1);
      items[to].focus();
    }
  });

  setActive(0, true);
  updateLb();
})();
</script>`
